import ReactModal from 'react-modal';
import { NavLink } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { AcctState } from 'stores/atoms/acctState';
/**
 * コンテンツ作成モーダル
 */
export default function WsModalCreateContent(props: {
  setOpen: (open: boolean) => void;
  open: boolean;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useRecoilState(AcctState);

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * モーダルを閉じた時の処理
   */
  const onClose = () => {
    props.setOpen(false);
  };

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <ReactModal
        isOpen={props.open}
        onRequestClose={onClose}
        style={{
          overlay: {
            zIndex: 2000,
            backgroundColor: 'rgba(30, 30, 30,0.5)',
          },
          content: {
            maxWidth: '800px',
          },
        }}
        className="ReactModal__Content__Custom"
        ariaHideApp={false}
      >
        <div
          id="settings-modal"
          className="modal2 modal-content rounded-4 "
          style={{ maxWidth: 'none' }}
        >
          <div className="modal-header border-bottom-0">
            <button onClick={onClose} type="button" className="btn-close btn-circle-close">
              <img src="/img/icon/multiply.svg" alt="x" />
            </button>
          </div>
          <div className="modal-body">
            <h3 className="modal-title text-center mt-5" id="settings-modal-label">
              どちらの形式で作成しますか
            </h3>
          </div>
          <div className="column" style={{ marginBottom: '3rem' }}>
            <div className="col-10" style={{ margin: '1.5rem auto' }}>
              <NavLink
                to={`/ws/${acctState.company.cd}/quiz/edit`}
                className="row w-100 btn btn-common"
                style={{ display: 'flex' }}
              >
                <div className="col-3">
                  <div className="card-img">
                    <img src="/img/icon/quiz-r.png" alt="question" style={{ width: '100px' }} />
                  </div>
                </div>
                <div className="col-7 my-auto">
                  <h4 className="card-title text-start">クイズ型</h4>
                </div>
              </NavLink>
              <p className="card-text" style={{ color: 'gray' }}>
                正解・不正解を競う形式で、クイズを通じてユーザーの関心を引きます。
                リード獲得やエンゲージメント向上に効果的なコンテンツです。
              </p>
            </div>
            <div className="col-10" style={{ margin: '1.5rem auto' }}>
              <NavLink
                to={`/ws/${acctState.company.cd}/diagnosis/edit`}
                className="row w-100 btn btn-common"
                style={{ display: 'flex' }}
              >
                <div className="col-3">
                  <div className="card-img">
                    <img src="/img/icon/dia-r.png" alt="question" style={{ width: '100px' }} />
                  </div>
                </div>
                <div className="col-7 my-auto">
                  <h4 className="card-title text-start">診断型</h4>
                </div>
              </NavLink>
              <p className="card-text" style={{ color: 'gray' }}>
                タイプ別に結果を分類し、性格診断やスキルチェックを提供します。
                リード獲得に役立ち、パーソナライズされた体験でユーザーの関心を引きます。
              </p>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
}
